import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { api, ui } from '../redux'

import Button from '../components/Button'

const PromoCodeButton = ({ dispatch, promoCode }) => {
    const [icon, intent] = promoCode.enabled
        ? ['md/check', ui.INTENT.success]
        : ['md/clear', ui.INTENT.error]

    const url = api.buildURL('promoCodes', { id: promoCode.id })

    return (
        <Button
            intent={ intent }
            size={ ui.SIZE.large }
            icon={ icon }
            onClick={ () => dispatch(api.update(url, { enabled: !promoCode.enabled })) }
        />
    )
}

PromoCodeButton.propTypes = {
    dispatch  : PropTypes.func.isRequired,
    promoCode : PropTypes.object
}

export default connect()(PromoCodeButton)
